module.exports = __webpack_public_path__ + "img/66.1.8ed29d6b.jpg";